import { render, staticRenderFns } from "./FolderOfferStep1.vue?vue&type=template&id=1b16b84e&scoped=true"
import script from "./FolderOfferStep1.vue?vue&type=script&lang=js"
export * from "./FolderOfferStep1.vue?vue&type=script&lang=js"
import style0 from "./FolderOfferStep1.vue?vue&type=style&index=0&id=1b16b84e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b16b84e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
